
import Vue from "vue"
import Router from "vue-router"

Vue.use(Router);

export default new Router({
	
	mode: "history",
	
	routes: [
		
		{
			path: "/dashboard",
			name: "dashboard",
			meta: { menu: true, icon: "globe", title: "Dashboard" },
			component: require("@/components/Dashboard/Dashboard").default,
			children: [
				{
					path: ":ticketId",
					name: "dashboard/ticket",
					meta: { title: "Ticket Details" },
					component: require("@/components/Dashboard/TicketItemView").default,
				}
			]
		},
		
		{
			path: "/clients",
			//name: "clients",
			meta: { auth: ["view_clients"], menu: true, icon: "contacts", title: "Clients" },
			component: require("@/components/Clients/Index").default,
			children: [
				{
					path: "",
					name: "clients",
					meta: { auth: ["view_clients"], title: "Clients" },
					component: require("@/components/Clients/Clients").default,
				},
				{
					path: ":clientSlug",
					//name: "clients/client",
					meta: { auth: ["view_clients"], title: "Client" },
					component: require("@/components/Clients/Client").default,
					children: [
						{
							path: "projects",
							name: "clients/client",
							meta: { title: "Projects", icon: "flask" },
							component: require("@/components/Clients/Projects").default,
						},
						/*{
							path: "files",
							name: "clients/client/files",
							meta: { title: "Files", icon: "attach" },
							component: require("@/components/Clients/Files").default,
						},
						{
							path: "notes",
							name: "clients/client/notes",
							meta: { title: "Notes", icon: "create" },
							component: require("@/components/Clients/Notes").default,
						},*/
						{
							path: "timebook",
							name: "clients/client/timebook",
							meta: { title: "Time Book", icon: "stopwatch" },
							component: require("@/components/Clients/TimeBook").default,
						},
						{
							path: "history",
							name: "clients/client/history",
							meta: { title: "History", icon: "git-commit" },
							component: require("@/components/Clients/History").default,
						},
						{
							path: "settings",
							name: "clients/client/settings",
							meta: { title: "Settings", icon: "settings" },
							component: require("@/components/Clients/Settings").default,
						},
					]
				}
			]
		},
		
		{
			path: "/projects",
			//name: "projects",
			meta: { auth: ["view_projects"], menu: true, icon: "flask", title: "Projects" },
			component: require("@/components/Projects/Index").default,
			children: [
				{
					path: "",
					name: "projects",
					meta: { auth: ["view_projects"], title: "Projects" },
					component: require("@/components/Projects/Projects").default,
				},
				{
					path: ":projectSlug",
					//name: "projects/project",
					meta: { auth: ["view_projects"], title: "Project" },
					component: require("@/components/Projects/Project/Project").default,
					children: [
						{
							path: "tasks",
							name: "projects/project",
							meta: { title: "Tasks", icon: "checkbox" },
							component: require("@/components/Projects/Project/TicketsList").default,
							children: [
								{
									path: ":ticketId",
									name: "projects/project/ticket",
									meta: { title: "Task", icon: "checkbox" },
									component: require("@/components/Projects/Project/TicketItemView").default,
								}
							],
						},
						{
							path: "timebook",
							name: "projects/project/timebook",
							meta: { title: "Time Book", icon: "stopwatch" },
							component: require("@/components/Projects/Project/TimeBook").default,
						},
						{
							path: "settings",
							name: "projects/project/settings",
							meta: { title: "Settings", icon: "settings" },
							component: require("@/components/Projects/Project/Settings").default,
						},
						/*{
							path: "files",
							name: "projects/project/files",
							meta: { title: "Files", icon: "attach" },
							component: require("@/components/Projects/Files").default,
						},
						{
							path: "notes",
							name: "projects/project/notes",
							meta: { title: "Notes", icon: "create" },
							component: require("@/components/Projects/Notes").default,
						},*/
					]
				}
			]			
		},
		
		{
			path: "/timebook",
			name: "timebook",
			meta: { auth: ["admin", "view_timebook"], menu: true, icon: "stopwatch", title: "Time Book" },
			component: require("@/components/TimeBook/TimeBook").default,
		},
		
		/*{
			path: "/notes",
			name: "notes",
			meta: { menu: true, icon: "create", title: "Notes" },
			component: require("@/components/Documents/Documents").default,
		},
		
		{
			path: "/files",
			name: "files",
			meta: { menu: true, icon: "attach", title: "Files" },
			component: require("@/components/Files/Files").default,
		},*/
		
		{
			path: "/users",
			//name: "users",
			meta: { auth: ["admin"], menu: true, icon: "finger-print", title: "User Access" },
			component: require("@/components/Users/Users").default,
			children: [
				{
					path: "",
					name: "users",
					component: require("@/components/Users/AddEdit").default,
					meta: { title: "New User", state: "add" },
				},
				{
					path: "edit/:id",
					name: "users/edit",
					component: require("@/components/Users/AddEdit").default,
					meta: { title: "Edit User", state: "edit" },
				}
			]
		},
		
		/*{
			path: "/settings",
			name: "settings",
			meta: { auth: ["admin"], menu: true, icon: "settings", title: "Settings" },
			component: require("@/components/Settings").default,
		},*/
		
		{
			path: "/my-profile",
			name: "my-profile",
			meta: { title: "My Profile" },
			component: require("@/components/MyProfile").default,
		},
		
		{
			path: "*",
			meta: {},
			redirect: "/dashboard"
		},
		
	]
	
})



// WEBPACK FOOTER //
// ./src/router/index.js